import { Field, TextOutput } from 'Components/Core';
import { SectionGroup, Table } from 'Components/Layout';
import { IInterLabActionHistory } from 'Data/ReduxViewModels/InterLab/types';
import { FormatTypes } from 'Lib/Format';

interface IInterLabTransferHistoryTableProps {
  copyHistories: IInterLabActionHistory[];
}

const InterLabCopyHistoryTable: React.FC<IInterLabTransferHistoryTableProps> = ({ copyHistories }) => {
  const OutputField = (value?: any, format?: any) => <Field input={<TextOutput />} value={value} format={format} />;

  return (
    <SectionGroup heading="Copy History">
      {copyHistories.length === 0 ? (
        <Field input={<TextOutput />} severity="info" value="This work order has not been previously copied." />
      ) : (
        <Table
          colHeaders={['Date', 'New Work Order ID', 'Copied By']}
          colWidths={['20%', ' ', '30%']}
          alternateRowShading={true}
          data={copyHistories.map((h) => [
            OutputField(h.executedAt, { type: FormatTypes.Date }),
            OutputField(h.newWorkOrderId),
            OutputField(h.executedBy),
          ])}
        />
      )}
    </SectionGroup>
  );
};

export { InterLabCopyHistoryTable };
